import { createAction } from "@ngrx/store";
import { ConnectionModel } from "../models/connection.model";
import { ConnectionLocationMasterModel } from "../models/sap.model";

export const ADD_CONNECTIONS = createAction(
  "ADD_CONNECTIONS",
  (connections: ConnectionModel[]) => ({
    connections,
  }),
);
export const ADD_CONNECTION = createAction(
  "ADD_CONNECTION",
  (connection: ConnectionModel) => ({
    connection,
  }),
);

export const UPDATE_CONNECTIONS = createAction(
  "UPDATE_CONNECTIONS",
  (connection: ConnectionModel) => ({ connection }),
);

export const UPDATE_CONNECTION = createAction(
  "UPDATE_CONNECTION",
  (connection: ConnectionModel) => ({ connection }),
);

export const ADD_CONNECTION_LOCATIONS = createAction(
  "ADD_CONNECTION_LOCATIONS",
  (connection: ConnectionLocationMasterModel[]) => ({
    connection,
  }),
);
